function IceSelected() {
  return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.25" cy="26" r="25.5" fill="#0D0F11" stroke="#0D0F11"/>
            <path
                d="M22.7774 40.3249H24.5362H26.2186H27.9774C30.8493 40.3249 33.1774 37.9968 33.1774 35.1249V33.8249V29.9249C33.1774 29.2069 32.5954 28.6249 31.8774 28.6249H22.7774H18.8774C18.1594 28.6249 17.5774 29.2069 17.5774 29.9249V33.8249V35.1249C17.5774 37.9968 19.9055 40.3249 22.7774 40.3249Z"
                stroke="white" strokeWidth="2"/>
            <path
                d="M34.0096 29.9249H36.2975C37.4462 29.9249 38.3775 30.8562 38.3775 32.0049V33.0449C38.3775 34.1937 37.4462 35.1249 36.2975 35.1249H33.1775"
                stroke="white" strokeWidth="2" stroke-linecap="round"/>
            <path d="M18.9082 20.3276V25.375" stroke="white" strokeWidth="1.10931" stroke-linecap="round"/>
            <path d="M16.7227 21.5894L21.0938 24.113" stroke="white" strokeWidth="1.10931" stroke-linecap="round"/>
            <path d="M16.7227 24.113L21.0938 21.5894" stroke="white" strokeWidth="1.10931" stroke-linecap="round"/>
            <path d="M25.3977 11.6749V18" stroke="white" strokeWidth="1.39013" stroke-linecap="round"/>
            <path d="M22.6589 13.2563L28.1366 16.4189" stroke="white" strokeWidth="1.39013" stroke-linecap="round"/>
            <path d="M22.6589 16.4187L28.1366 13.2562" stroke="white" strokeWidth="1.39013" stroke-linecap="round"/>
            <path d="M31.8872 20.3276V25.375" stroke="white" strokeWidth="1.10931" stroke-linecap="round"/>
            <path d="M29.7017 21.5894L34.0728 24.113" stroke="white" strokeWidth="1.10931" stroke-linecap="round"/>
            <path d="M29.7017 24.113L34.0728 21.5894" stroke="white" strokeWidth="1.10931" strokeLinecap="round"/>
        </svg>

  );
}

export default IceSelected;
